import { Grid2 } from '@mui/material';
import React, { useMemo } from 'react';
import CardAdministrador from '../../../../components/ui/materialui/cardAdministrador';
import { BrightnessHigh, FactCheck, HealthAndSafety, HowToReg, MoveToInbox, Payments } from '@mui/icons-material';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';

interface SecureLink {
    to: string;
    icon: JSX.Element;
    text: string;
    permissions: TipoFuncionalidad[];
}

const MinvuPage: React.FC = () => {
    const { hasPermission } = usePermissions();

    const linksPermitidos = useMemo(() => {
        const todosLosLinks: SecureLink[] = [
            { 
                to: "/minvu/beneficios", 
                icon: <FactCheck sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Validar beneficios",
                permissions: [TipoFuncionalidad.Minvu_ADM] 
            },
            { 
                to: "/minvu/respuesta-validacion", 
                icon: <HowToReg sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Respuesta validación",
                permissions: [TipoFuncionalidad.Minvu_ADM] 
            },
            { 
                to: "/minvu/cobrar-beneficios", 
                icon: <Payments sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Cobrar beneficios",
                permissions: [TipoFuncionalidad.Minvu_ADM] 
            },
            { 
                to: "/minvu/respuesta-cobro", 
                icon: <MoveToInbox sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Respuesta cobro",
                permissions: [TipoFuncionalidad.Minvu_ADM] 
            },
            { 
                to: "/minvu/seguro-cesantia", 
                icon: <HealthAndSafety sx={{ fontSize: 22, color: "#17c2e6" }} />, 
                text: "Cobro seguro cesantía",
                permissions: [TipoFuncionalidad.Minvu_ADM] 
            },
        ];

        return todosLosLinks.filter(link => 
            link.permissions.some(perm => hasPermission(perm))
        );
    }, [hasPermission]);

    if (linksPermitidos.length === 0) return null;

    return (
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
            <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                <CardAdministrador
                    title="Beneficios MINVU"
                    icon={<BrightnessHigh sx={{ fontSize: 20, color: "white" }} />}
                    links={linksPermitidos}
                    backgroundColor="#17c2e6"
                    linkTextColor="text-info"
                />
            </Grid2>
        </Grid2 >
    );
};

export default MinvuPage;